import Photo from './Photo'

export default Photo
